import env from '../env';
import {AUTH_MODE, storeAppSession} from '../auth/authStorage';
import {decodeAppToken} from '../auth/token';

const saveWebToken = (token) => {
    const decoded = decodeAppToken(token);

    storeAppSession(token, decoded, AUTH_MODE.SSO);

    return {token, decoded};
};

export const exchangeKeycloakCode = async ({code, codeVerifier, uiOrigin}) => {
    if (!code) {
        console.error('exchangeKeycloakCode: No code provided');
        throw new Error('No Keycloak authorization code to exchange');
    }

    const response = await fetch(`${env.baseURL}/api/public/login-sso-partner`, {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({
            code,
            codeVerifier,
            partnerId: env.partnerId,
            uiOrigin,
        }),
    });

    if (response.status < 200 || response.status >= 300) {
        console.error('SSO code exchange failed:', response.status, response.statusText);
        throw new Error(response.statusText || `HTTP ${response.status}`);
    }

    const json = await response.json();
    return saveWebToken(json.token);
};

export const exchangeKeycloakToken = async (keycloakToken) => {
    if (!keycloakToken) {
        console.error('exchangeKeycloakToken: No token provided');
        throw new Error('No Keycloak token to exchange');
    }

    const response = await fetch(`${env.baseURL}/api/public/login-sso-partner`, {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({authToken: keycloakToken, partnerId: env.partnerId}),
    });

    if (response.status < 200 || response.status >= 300) {
        console.error('Token exchange failed:', response.status, response.statusText);
        throw new Error(response.statusText || `HTTP ${response.status}`);
    }

    const json = await response.json();
    const result = saveWebToken(json.token);
    localStorage.setItem('keycloakToken', keycloakToken);
    return result;
};
